/**
 * Car details / listing page labels
 */

import svCarDetails from '../locales/sv/carDetails.json';
import enCarDetails from '../locales/en/carDetails.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

const getCarDetailsLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enCarDetails : svCarDetails;
};

export const carDetailsLabels = (lang?: Language) => {
  return getCarDetailsLocale(lang);
};
